import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus, HelpCircle } from "lucide-react";
import { FAQS } from "@/data/seoData";

export function FAQSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="relative py-24 border-t border-white/10 bg-slate-900/40" data-testid="faq-section">
      <div className="absolute inset-0 blueprint-grid opacity-10 pointer-events-none" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-12">
          <span className="overline inline-flex items-center gap-2">
            <HelpCircle className="w-3.5 h-3.5 text-orange-500" /> Questions &amp; Answers
          </span>
          <div className="section-divider-left mt-3" />
          <h2
            className="text-white mt-4"
            style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 800,
              fontSize: "clamp(2rem, 3vw, 2.8rem)",
              textTransform: "uppercase",
              lineHeight: 1.1,
            }}
          >
            Frequently Asked Questions
          </h2>
          <p className="text-slate-400 text-sm mt-3 max-w-2xl">
            Everything about buying SIDA-approved industrial plots at IIE Sigaddi, SIIDCUL Kotdwar, Uttarakhand.
          </p>
        </div>

        <div className="divide-y divide-white/[0.08] border-y border-white/[0.08]" itemScope itemType="https://schema.org/FAQPage">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-4 text-left py-5 group"
                  data-testid={`faq-question-${i}`}
                >
                  <span
                    className="text-slate-100 text-base md:text-lg font-medium group-hover:text-orange-400 transition-colors"
                    itemProp="name"
                  >
                    {item.q}
                  </span>
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center border border-orange-500/40 text-orange-500 mt-0.5">
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                      itemScope
                      itemProp="acceptedAnswer"
                      itemType="https://schema.org/Answer"
                    >
                      <p
                        className="text-slate-400 text-sm leading-relaxed pb-6 pr-10"
                        itemProp="text"
                        data-testid={`faq-answer-${i}`}
                      >
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
